import { render, staticRenderFns } from "./FormNavigationButtons.vue?vue&type=template&id=53cbc722&"
import script from "./FormNavigationButtons.vue?vue&type=script&lang=ts&"
export * from "./FormNavigationButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53cbc722')) {
      api.createRecord('53cbc722', component.options)
    } else {
      api.reload('53cbc722', component.options)
    }
    module.hot.accept("./FormNavigationButtons.vue?vue&type=template&id=53cbc722&", function () {
      api.rerender('53cbc722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/common/FormNavigationButtons.vue"
export default component.exports